/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_License_FcInputs */

const en_fc_cmp_license_fc = /** @type {(inputs: Fc_Cmp_License_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source (MIT / Apache-2.0)`)
};

/**
* | output |
* | --- |
* | "Open source (MIT / Apache-2.0)" |
*
* @param {Fc_Cmp_License_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_license_fc = /** @type {((inputs?: Fc_Cmp_License_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_License_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_license_fc(inputs)
});
export { fc_cmp_license_fc as "fc.cmp.license.fc" }